export default "__VITE_ASSET__10a0eca3__"